.control-container {
    flex-direction: row;
    display: flex;
    flex-wrap: wrap;
    border-radius: 3px;
    padding: 4px;
}

.control-container--connected {
    background-color: var(--off-white);
}

.control-container--separated {
    background-color: transparent;
    gap: 16px;
}

.control-container--no-padding {
    padding: 0;
}

.control-container--disabled {
    opacity: 0.6;
    pointer-events: none;
}

.control-container--separated .button-content {
    border-radius: 3px;
    border: 1px solid var(--Neutral-border, #ebe8e8);
    background: var(--Neutral-white, #fff);

    /* Card */
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
}

.button-content {
    display: flex;
    flex-direction: column;
    text-align: center;
}

.button-content--small {
    composes: button-content;
    padding: 8px 16px;
}

.button-content--large {
    composes: button-content;
    text-align: left;
    padding: 16px;
}

.button-content--animated {
    animation: bounceContent 0.4s ease-out;
}

.button-content--hovered {
    transform: translateY(-1px);
    transition: transform 0.2s ease-out;
}

.button-content--icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}

.title {
    font-weight: normal;
    color: var(--grey-dk);
    font-size: var(--font-small);
    line-height: 21px;
}

.title--selected {
    composes: title;
    font-weight: 500;
}

.title--large {
    composes: title--selected;
    padding-bottom: 4px;
    font-size: var(--font-normal);
}

.inner-text {
    font-weight: normal;
    color: var(--grey-lt);
    font-size: var(--font-small);
    line-height: 19px;
}

.button-card--bouncy {
    animation: bounceCard 0.4s ease-out;
    transform-origin: center;
}

.button-card--hovered {
    transform: scale(1.02);
    transition: transform 0.2s ease-out;
}

@keyframes bounceCard {
    0% {
        transform: scale(1);
    }
    25% {
        transform: scale(1.03);
    }
    50% {
        transform: scale(0.99);
    }
    75% {
        transform: scale(1.01);
    }
    100% {
        transform: scale(1);
    }
}

@keyframes bounceContent {
    0% {
        transform: translateY(0);
    }
    40% {
        transform: translateY(-2px);
    }
    80% {
        transform: translateY(0);
    }
    100% {
        transform: translateY(0);
    }
}
